import _ from 'lodash';

export function formatDate(
  date,
  options = { year: 'numeric', month: 'long', day: 'numeric' }
) {
  return new Date(date).toLocaleDateString(['it-IT'], options);
}

/**
 * @param {date} string    A string value representing a date.
 */
export function getMonth(date) {
  return new Date(date).getMonth() + 1;
}

/**
 * @param {date} string    A string value representing a date.
 */
export function getDay(date) {
  return new Date(date).getDate();
}

/**
 * @param {date} string    A string value representing a date.
 */
export function getHours(date) {
  return new Date(date)
    .getHours()
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

/**
 * @param {date} string    A string value representing a date.
 */
export function getMinutes(date) {
  return new Date(date)
    .getMinutes()
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

/**
 * @param {date} string    A string value representing a date.
 */
export function getWeekDay(date) {
  // Create an array containing each day, starting with Sunday.
  const weekdays = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  // Return the element that corresponds to that index.
  return weekdays[new Date(date).getDay()];
}

/**
 * @param {time} string    A string value representing a date time.
 */
export default function getDateObject(t) {
  // const time = t.substring(0, 19);
  // console.log('time is', t);
  // console.log('time 2 is', t.substring(0, 19));
  const time = t;

  // console.log('orig', {
  //   orig: time,
  //   year: formatDate(time, { year: 'numeric' }),
  //   monthNumber: getMonth(time),
  //   monthName: capitalizeFirstLetter(formatDate(time, { month: 'short' })),
  //   day: getDay(time),
  //   hours: `${getHours(time)}:${getMinutes(time)}`,
  //   weekday: getWeekDay(time),
  // });

  // time = t.substring(0, 19);

  // console.log('orig2', {
  //   orig: time,
  //   year: formatDate(time, { year: 'numeric' }),
  //   monthNumber: getMonth(time),
  //   monthName: capitalizeFirstLetter(formatDate(time, { month: 'short' })),
  //   day: getDay(time),
  //   hours: `${getHours(time)}:${getMinutes(time)}`,
  //   weekday: getWeekDay(time),
  // });
  // time = t;

  return {
    orig: t,
    year: formatDate(time, { year: 'numeric' }),
    monthNumber: getMonth(time),
    monthName: capitalizeFirstLetter(formatDate(time, { month: 'short' })),
    day: getDay(time),
    hours: `${getHours(time)}:${getMinutes(time)}`,
    weekday: getWeekDay(time),
  };
}

/**
 * @param {string} string    A string value.
 */
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getFirstDayOfWeek(d) {
  const day2 = d.getDay();
  const diff = d.getDate() - day2 + (day2 === 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}
export function getLastDayOfWeek(d) {
  const day2 = d.getDay();
  const diff = d.getDate() - day2 + 7; // adjust when day is sunday
  return new Date(d.setDate(diff));
}
/**
 * @param {dayRange} number  A number indicating the day range .
 */
export function getAllDays(dayRange) {
  const today = new Date();
  const firstDay = new Date(today);

  firstDay.setDate(today.getDate() + 1);
  const lastDay = new Date(today);
  lastDay.setDate(today.getDate() + dayRange);

  // Calculate the first day of the week before the first day
  const firstDayOfWeek = getFirstDayOfWeek(firstDay);
  // calculates the last day of the week after the last day
  const lastDayOfWeek = getLastDayOfWeek(lastDay);
  // calcluates the number of whole days between the bove days
  const timeDiff = lastDayOfWeek.getTime() - firstDayOfWeek.getTime();
  const DaysDiff = Math.round(timeDiff / (1000 * 3600 * 24));

  const dayArray = [
    {
      date: firstDayOfWeek,
      day: firstDayOfWeek.getDate(),
      month: firstDayOfWeek.getMonth() + 1,
      weekday: getWeekDay(firstDayOfWeek),
    },
  ];

  for (let i = 1; i <= DaysDiff; i += 1) {
    const date = new Date(dayArray[i - 1].date.getTime() + 24 * 60 * 60 * 1000);
    dayArray[i] = {
      date,
      day: date.getDate(),
      month: date.getMonth() + 1,
      weekday: getWeekDay(date),
    };
  }

  return dayArray.map((item) => ({
    ...item,
    // date: item.date.toISOString(),
    monthName: capitalizeFirstLetter(formatDate(item.date, { month: "short" })),
    year: item.date.getFullYear(),
    timestamp: item.date.getTime(),
    active:
      item.weekday === "dom"
        ? false
        : item.month === today.getMonth() + 1
        ? item.day >= today.getDate() + 1
        : true,
  }));
}
/**
 * @param {items} array  The array of items.
 * @param {page} number  The current page.
 * @param {pageSize} number  The number of items in each page.
 */
export function getPaginatedItems(items, page, pageSize) {
  const offset = (parseInt(page, 10) - 1) * parseInt(pageSize, 10);
  const pagedItems = _.drop(items, offset).slice(0, pageSize);
  return pagedItems;
}

function getUnique(arr, comp) {
  const unique = arr
    .map((e) => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}
function getHourInMinute(hour) {
  const hoursArray = hour.split(':');

  return parseInt(hoursArray[0], 10) * 60 + parseInt(hoursArray[1], 10);
}

function formatMinutesToHours(minutes) {
  return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(
    minutes % 60
  ).padStart(2, '0')}`;
}
function getSplitedHourArray(startHour, finishHour, durationInMinute, id) {
  const timeArray = [startHour];
  // calculates the diffrenece from finish and start hour in minute
  const hoursDifferences =
    getHourInMinute(finishHour) - getHourInMinute(startHour);
  // calculates the number of time slots
  const timeSlots = Math.floor(hoursDifferences / durationInMinute);
  // poplulates array with new time slots in hour
  for (let i = 0; i <= timeSlots; i += 1) {
    timeArray[i] = formatMinutesToHours(
      getHourInMinute(startHour) + i * durationInMinute
    );
  }

  const finalArray = [];
  for (let i = 1; i < timeArray.length; i += 1) {
    finalArray.push({
      hours: `${timeArray[i - 1]}-${timeArray[i]}`,
      mapadore_event_id: id,
    });
  }

  return finalArray;
}

export function sortBy(field) {
  return function (a, b) {
    if (a[field] > b[field]) {
      return 1;
    }
    if (a[field] < b[field]) {
      return -1;
    }
    return 0;
  };
}
function getSplitedHours(hours, durationInMinute) {
  // hours.hours

  // hours.mapadore_event_id
  let finalHours = [];
  for (let i = 0; i < hours.length; i += 1) {
    finalHours = [
      ...finalHours,
      ...getSplitedHourArray(
        hours[i].hours.split('-')[0],
        hours[i].hours.split('-')[1],
        durationInMinute,
        hours[i].mapadore_event_id
      ),
    ];
  }

  finalHours.sort(sortBy('hours'));

  return finalHours;
}

export function getAllHours(dates, day, month, isRange, duration) {
  return isRange
    ? getUnique(
        getSplitedHours(
          getUnique(
            dates
              .filter(
                (element) =>
                  element.appointment.time.startTime.monthNumber === month &&
                  element.appointment.time.startTime.day === day
              )
              .map((itm) => ({
                hours: `${itm.appointment.time.startTime.hours}-${itm.appointment.time.finishTime.hours}`,
                mapadore_event_id: itm.appointment.mapadore_event_id,
              }))
              .sort(),
            'hours'
          ),
          duration
        ),
        'hours'
      )
    : getUnique(
        dates
          .filter(
            (element) =>
              element.appointment.time.startTime.monthNumber === month &&
              element.appointment.time.startTime.day === day
          )
          .map((itm) => ({
            hours: `${itm.appointment.time.startTime.hours}-${itm.appointment.time.finishTime.hours}`,
            mapadore_event_id: itm.appointment.mapadore_event_id,
          }))
          .sort(),
        'hours'
      );
}

export function getEvent(dates, mapadoreEvenTd, hours) {
  // const startTime = new Date(
  //   itm.appointment.time.startTime.year,
  //   itm.appointment.time.startTime.monthNumber - 1,
  //   itm.appointment.time.startTime.day,
  //   parseInt(hours.split('-')[0].split(':')[0], 10) + 1,
  //   parseInt(hours.split('-')[0].split(':')[1], 10)
  // );

  // const finishTime = new Date(
  //   itm.appointment.time.finishTime.year,
  //   itm.appointment.time.finishTime.monthNumber - 1,
  //   itm.appointment.time.finishTime.day,
  //   parseInt(hours.split('-')[1].split(':')[0], 10) + 1,
  //   parseInt(hours.split('-')[1].split(':')[1], 10)
  // );
  // console.log(startTime, finishTime);
  // startTime.toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
  // finishTime.toLocaleString('it-IT', { timeZone: 'Europe/Rome' });

  // console.log(startTime, finishTime);
  // console.log(startTime, finishTime);

  return dates
    .filter(
      (element) =>
        element.appointment.mapadore_event_id === parseInt(mapadoreEvenTd, 10)
    )
    .map((itm) => {
      const startTime = new Date(
        Date.UTC(
          itm.appointment.time.startTime.year,
          itm.appointment.time.startTime.monthNumber - 1,
          itm.appointment.time.startTime.day,
          parseInt(hours.split('-')[0].split(':')[0], 10),
          parseInt(hours.split('-')[0].split(':')[1], 10)
        )
      );

      const finishTime = new Date(
        Date.UTC(
          itm.appointment.time.finishTime.year,
          itm.appointment.time.finishTime.monthNumber - 1,
          itm.appointment.time.finishTime.day,
          parseInt(hours.split('-')[1].split(':')[0], 10),
          parseInt(hours.split('-')[1].split(':')[1], 10)
        )
      );

      // console.log({
      //   target_address: itm.appointment.location.target_address,
      //   start_time: `${startTime.toISOString().split('.000Z')[0]}+02:00`,
      //   finish_time: `${finishTime.toISOString().split('.000Z')[0]}+02:00`,
      //   latitude: itm.appointment.location.latitude,
      //   longitude: itm.appointment.location.longitude,
      //   mapadore_event_id: itm.appointment.mapadore_event_id,
      //   operator_id: itm.appointment.operator_id,
      //   target_id: itm.appointment.target_id,
      // });

      // startTime.setTime(
      //   startTime.getTime() + startTime.getTimezoneOffset() * 60 * 1000
      // );
      // finishTime.setTime(
      //   finishTime.getTime() + finishTime.getTimezoneOffset() * 60 * 1000
      // );

      // const options = {
      //   year: '2-digit',
      //   month: '2-digit',
      //   day: '2-digit',
      //   hour: '2-digit',
      //   minute: '2-digit',
      //   second: '2-digit',
      //   timeZone: 'Europe/Rome',
      //   timeZoneName: 'short',
      // };
      // const formater = new Intl.DateTimeFormat('it-IT', options);

      // console.log(
      //   'event',
      //   `${startTime.toISOString().split('.000Z')[0]}+02:00`,
      //   `${finishTime.toISOString().split('.000Z')[0]}+02:00`
      // );

      return {
        target_address: itm.appointment.location.target_address,
        start_time: `${startTime.toISOString().split('.000Z')[0]}+01:00`,
        finish_time: `${finishTime.toISOString().split('.000Z')[0]}+01:00`,
        latitude: itm.appointment.location.latitude,
        longitude: itm.appointment.location.longitude,
        mapadore_event_id: itm.appointment.mapadore_event_id,
        operator_id: itm.appointment.operator_id,
        target_id: itm.appointment.target_id,
      };
    });
}
